import {
    Component,
    Host,
    h,
    Prop,
    Event,
    EventEmitter,
    Watch,
    Element,
} from "@stencil/core";

export interface ActiveHotSpotChangeEventData {
    activeHotSpot: string;
}

const baseClass = "ux-iws-hot-spot-container";

@Component({
    tag: "ux-iws-hot-spot-container",
    styleUrl: "hot-spot-container.scss",
    shadow: false,
})
export class HotSpotContainer {
    @Element() element: HTMLUxIwsHotSpotContainerElement;

    /**
     * The active hot spot id
     */
    @Prop({
        reflect: true,
        mutable: true,
    })
    activeHotSpot = "";

    /**
     * Event emitted when the active hot spot changes
     */
    @Event({
        eventName: "uxActiveHotSpotChange",
        composed: true,
        cancelable: true,
        bubbles: true,
    })
    activeHotSpotChange: EventEmitter<ActiveHotSpotChangeEventData>;

    @Watch("activeHotSpot")
    activeHotSpotChanged() {
        this.activeHotSpotChange.emit({ activeHotSpot: this.activeHotSpot });
    }

    componentWillLoad() {
        if (this.activeHotSpot === "") {
            this.activeHotSpot =
                this.element.querySelector("ux-iws-hot-spot")?.hotSpotId || "";
        }
    }

    render() {
        return (
            <Host class={baseClass}>
                <div class={`${baseClass}__hot-spot-area`}>
                    <slot name="image"></slot>
                    <slot name="hot-spots"></slot>
                </div>
                <div class={`${baseClass}__info-box__container`}>
                    <div class="ux-row ux-u-flex-jc-center ux-u-flex-jc-lg-start">
                        <div class="ux-col-11 ux-col-sm-10 ux-col-lg-6 ux-u-offset-lg-4 u-textCenter@m">
                            <div class={`${baseClass}__info-box__outer`}>
                                <div class={`${baseClass}__info-box__inner`}>
                                    <slot name="info-box"></slot>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Host>
        );
    }
}
